import React, { useEffect } from "react";
import { useFormik } from "formik";
import { TvNotificationSchema } from "../../schema/schema";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import { useDispatch, useSelector } from "react-redux";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { tvStakeholderAdd, tvStakeholderUpdate } from "../../data/ApiEndpoints";
import { toast } from "react-toastify";
import SelectDropdownLabel from "../components-react/SelectDropdownLabel";
import { stakeholderOptions } from "./tv-utils";

const TvNotificationUpdate = ({
  callFunction,
  initialValues,
  isEdit,
  token,
  closeModal,
  isRoleWise,
}) => {
  const dispatch = useDispatch();

  const generateOptions = (range) =>
    [...Array(range).keys()].map((num) => ({
      label: num.toString().padStart(2, "0"),
      value: num.toString().padStart(2, "0"),
    }));

  const formik = useFormik({
    initialValues: {
      time_from: initialValues ? initialValues.time_from : "",
      time_to: initialValues ? initialValues.time_to : "",
      notification_role: initialValues ? initialValues.notification_role : "",
    },
    validationSchema: TvNotificationSchema,

    onSubmit: async (values) => {
      const method = isEdit ? "PUT" : "POST";
      const endpoint = isEdit ? tvStakeholderUpdate : tvStakeholderAdd;

      const payload = {
        ...(initialValues?.uid && { uid: initialValues.uid }),
        // user_id: values.user_id,
        time_from: values.time_from,
        time_to: values.time_to,
        notification_role: values.notification_role,
      };

      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      console.log("result is==>", result);

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    },
  });

  // console.log("formik values", formik.values);

  const handleTimeChange = (field, subField, value) => {
    // Split the existing value of the target field into HH, MM, and SS parts
    const [hh = "00", mm = "00", ss = "00"] = formik.values[field].split(":");

    // Update only the part of the time being changed
    const updatedTime = {
      hh,
      mm,
      ss,
      [subField]: value.padStart(2, "0"), // Ensure 2-digit format (e.g., "01", "09")
    };

    // Construct the updated time string
    const newTimeValue = `${updatedTime.hh}:${updatedTime.mm}:${updatedTime.ss}`;

    // Update the formik field value for the target field
    formik.setFieldValue(field, newTimeValue);
  };

  return (
    <div className="createNewCTOModalContainer mod-width-70p">
      <CommonHeadingNBtns
        title={`${isEdit ? "Edit" : "Add"} TV Role`}
        btnTxt={isEdit ? "Update" : "Save"}
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        onClose={closeModal}
      />

      <form className="formContainer" onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid twoGridSystem">
          {/* {isRoleWise && ( */}
          <div>
            <label htmlFor="notification_role" className="labelTv">
              {isRoleWise ? "Notification Role" : "StakeHolder Type"}
              <span className="text-danger">*</span>
            </label>
            <div className="commonWrapper dropdownCommonWrapper">
              <SelectDropdownLabel
                name={isRoleWise ? "Notification Role" : "StakeHolder Type"}
                options={stakeholderOptions}
                value={stakeholderOptions.find(
                  (option) => option.value === formik.values.notification_role
                )}
                setSelectedOption={(selectedOption) =>
                  formik.setFieldValue(
                    "notification_role",
                    selectedOption?.value
                  )
                }
              />
            </div>
            {formik.touched.notification_role &&
              formik.errors.notification_role && (
                <div className="error-message pt-1">
                  {formik.errors.notification_role}
                </div>
              )}
          </div>
          {/* )} */}

          <div>
            <label className="pb-2">
              Time From
              <span className="text-danger">*</span>
            </label>
            <div className="formInputsGrid threeGridSystem">
              {/* HH Field */}

              <div className="select-wrapper">
                {/* <label htmlFor="time_interval_hh" className="labelTv">
                HH
              </label> */}
                <div className="commonWrapper dropdownCommonWrapper">
                  <SelectDropdownLabel
                    name="HH"
                    options={generateOptions(24)} // Options for 0-23
                    value={
                      formik.values.time_from.split(":")[0]
                        ? {
                            label: formik.values.time_from.split(":")[0],
                            value: formik.values.time_from.split(":")[0],
                          }
                        : null
                    }
                    setSelectedOption={(selectedOption) =>
                      handleTimeChange(
                        "time_from",
                        "hh",
                        selectedOption?.value || "00"
                      )
                    }
                  />
                </div>
              </div>

              {/* MM Field */}
              <div className="select-wrapper">
                {/* <label htmlFor="time_interval_mm" className="labelTv">
                MM
              </label> */}
                <div className="commonWrapper dropdownCommonWrapper">
                  <SelectDropdownLabel
                    name="MM"
                    options={generateOptions(60)} // Options for 0-23
                    value={
                      formik.values.time_from.split(":")[1]
                        ? {
                            label: formik.values.time_from.split(":")[1],
                            value: formik.values.time_from.split(":")[1],
                          }
                        : null // Null when no value is selected
                    }
                    setSelectedOption={(selectedOption) =>
                      handleTimeChange(
                        "time_from",
                        "mm",
                        selectedOption?.value || "00"
                      )
                    }
                  />
                </div>
              </div>

              {/* SS Field */}
              <div className="select-wrapper">
                {/* <label htmlFor="time_interval_ss" className="labelTv">
                SS
              </label> */}
                <div className="commonWrapper dropdownCommonWrapper">
                  <SelectDropdownLabel
                    name="SS"
                    options={generateOptions(60)} // Options for 0-59
                    value={
                      formik.values.time_from.split(":")[2]
                        ? {
                            label: formik.values.time_from.split(":")[2],
                            value: formik.values.time_from.split(":")[2],
                          }
                        : null // Null when no value is selected
                    }
                    setSelectedOption={(selectedOption) =>
                      handleTimeChange(
                        "time_from",
                        "ss",
                        selectedOption?.value || "00"
                      )
                    }
                  />
                </div>
              </div>
            </div>

            {/* Validation Error Message */}
            {formik.touched.time_from && formik.errors.time_from && (
              <div className="error-message pt-1">
                {formik.errors.time_from}
              </div>
            )}
          </div>

          <div>
            <label className="pb-2">
              Time To
              <span className="text-danger">*</span>
            </label>
            <div className="formInputsGrid threeGridSystem">
              {/* <label>Time To</label> */}
              <div className="select-wrapper">
                <div className="commonWrapper dropdownCommonWrapper">
                  <SelectDropdownLabel
                    name="HH"
                    options={generateOptions(24)} // Options for 0-23
                    value={
                      formik.values.time_to.split(":")[0]
                        ? {
                            label: formik.values.time_to.split(":")[0],
                            value: formik.values.time_to.split(":")[0],
                          }
                        : null
                    }
                    setSelectedOption={(selectedOption) =>
                      handleTimeChange(
                        "time_to",
                        "hh",
                        selectedOption?.value || "00"
                      )
                    }
                  />
                </div>
              </div>

              <div className="select-wrapper">
                <div className="commonWrapper dropdownCommonWrapper">
                  <SelectDropdownLabel
                    name="MM"
                    options={generateOptions(60)} // Options for 0-23
                    value={
                      formik.values.time_to.split(":")[1]
                        ? {
                            label: formik.values.time_to.split(":")[1],
                            value: formik.values.time_to.split(":")[1],
                          }
                        : null // Null when no value is selected
                    }
                    setSelectedOption={(selectedOption) =>
                      handleTimeChange(
                        "time_to",
                        "mm",
                        selectedOption?.value || "00"
                      )
                    }
                  />
                </div>
              </div>

              <div className="select-wrapper">
                <div className="commonWrapper dropdownCommonWrapper">
                  <SelectDropdownLabel
                    name="SS"
                    options={generateOptions(60)}
                    value={
                      formik.values.time_to.split(":")[2]
                        ? {
                            label: formik.values.time_to.split(":")[2],
                            value: formik.values.time_to.split(":")[2],
                          }
                        : null
                    }
                    setSelectedOption={(selectedOption) =>
                      handleTimeChange(
                        "time_to",
                        "ss",
                        selectedOption?.value || "00"
                      )
                    }
                  />
                </div>
              </div>
            </div>
            {formik.touched.time_to && formik.errors.time_to && (
              <div className="error-message pt-1">{formik.errors.time_to}</div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default TvNotificationUpdate;

// const { inhouseUsers } = useSelector((state) => state.dropdown);

// useEffect(() => {
//   dispatch(
//     fetchInHouseUsersData({
//       token,
//       qps: "",
//       pageNo: 1,
//       limit: 100,
//     })
//   );
// }, [dispatch, token]);

{
  /* {!isRoleWise && (
            <div>
              <label htmlFor="user_id" className="labelTv">
                User
              </label>
              <div className="commonWrapper dropdownCommonWrapper">
                <SelectDropdownLabel
                  name="Select User"
                  options={inhouseUsers || []}
                  value={inhouseUsers?.find(
                    (option) => option.value === formik.values.user_id
                  )}
                  setSelectedOption={(selectedOption) =>
                    formik.setFieldValue("user_id", selectedOption?.value)
                  }
                />
              </div>
              {formik.touched.user_id && formik.errors.user_id && (
                <div className="error-message">{formik.errors.user_id}</div>
              )}
            </div>
          )} */
}
